"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactRouter = require("react-router");
const TileWrapper = _styled.default.div({
  alignItems: 'center',
  display: 'inline-flex',
  flexDirection: 'column',
  height: '55vw',
  margin: '8px',
  maxHeight: '250px',
  maxWidth: '282.5px',
  minWidth: '75px',
  width: '45vw'
});
const TitleTextWrapper = _styled.default.div(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'inline-flex',
    flexDirection: 'column',
    fontWeight: theme.fontWeights.semiBold,
    marginBottom: '10px',
    marginTop: '10px',
    textAlign: 'center'
  };
});
const TextWrapper = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: '-webkit-box',
    flexDirection: 'column',
    fontSize: theme.fontSizes.small,
    height: '25%',
    marginLeft: '5px',
    marginRight: '5px',
    textAlign: 'center',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '3',
    WebkitBoxPack: 'end',
    overflow: 'hidden',
    paddingBottom: '7px'
  };
});
const CarouselTile = _ref3 => {
  let {
    benefitId = '',
    description,
    inFocus = true,
    link = '',
    tileImage,
    title
  } = _ref3;
  const history = (0, _reactRouter.useHistory)();
  const convertToVW = val => {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return val * w / 100;
  };
  const TileImage = _styled.default.div({
    opacity: inFocus ? '100%' : '40%',
    background: `url(${tileImage}) no-repeat`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: '15px',
    width: '100%',
    height: '100%',
    maxWidth: '262.5px',
    // 150% of 175
    maxHeight: '175px',
    marginBottom: '5px'
  });
  const handleOnClick = () => {
    if (benefitId) {
      history.push(`/member-benefits/${benefitId}`);
    } else {
      window.location.href = link;
    }
  };
  const addEllipsisIfCharLimit = (text, charLimit) => {
    if ((text === null || text === void 0 ? void 0 : text.length) > charLimit) {
      return text.slice(0, charLimit).concat('...');
    }
    return text;
  };
  return /*#__PURE__*/_react.default.createElement(TileWrapper, {
    onClick: handleOnClick
  }, /*#__PURE__*/_react.default.createElement(TileImage, null), /*#__PURE__*/_react.default.createElement(TitleTextWrapper, null, title), /*#__PURE__*/_react.default.createElement(TextWrapper, null, addEllipsisIfCharLimit(description, convertToVW(45) / 6)));
};
var _default = exports.default = CarouselTile;